export const font = {
    primaryRegular: 'Basier-Regular',
    primaryMedium: 'Basier-Medium',
    primarySemiBold: 'Basier-SemiBold',
    primaryBold: 'Basier-Bold',
};

export type Font = typeof font;
